import { createAction } from '@ngrx/store';

export const loadAiPanel = createAction('[AI Panel] Load AI Panel');
